<template>
	<div class="page-container">
		<div class="search-bar bg_a">
			<router-link :to="{ path: '/main/merchant' }" class="index_search flex_a font_size_b">
				<van-icon name="search" />
				<div style="margin-left: 10px;">输入关键字搜索</div>
			</router-link>
		</div>

		<div class="content">
			<div class="index_swiper bg_a" v-if="banners.length > 0">
				<van-swipe class="swiper-item" indicator-color="#000">
					<van-swipe-item v-for="group in bannerGroups" :key="group[0].id" class="swiper-item">
						<div class="brand-grid">
							<div class="brand-item flex_b" v-for="item in group" :key="item.id" @click="goDetail(item.id)">
								<div class="brand-logo">
									<img v-if="item.logo" class="brand-logo-img" :src="getImageUrl(item.logo)" />
								</div>
								<div class="brand-name ellipsis_1">{{ item.retailerName }}</div>
								<div class="brand-rebate">最高 <span style="font-weight: bold;">{{ item.memberCommissionValue }}%</span>
									返利
								</div>
							</div>
						</div>
					</van-swipe-item>
				</van-swipe>
			</div>

			<div class="ranking-tabs flex_b">
				<div class="ranking-tab" :class="{ active: activeTab === 'hot' }" @click="onTabChange('hot')">
					<div class="ranking-title">热门</div>
					<div class="ranking-subtitle">最受欢迎</div>
				</div>
				<div class="ranking-tab" :class="{ active: activeTab === 'high' }" @click="onTabChange('high')">
					<div class="ranking-title">高返</div>
					<div class="ranking-subtitle">最多返利</div>
				</div>
				<div class="ranking-tab" :class="{ active: activeTab === 'new' }" @click="onTabChange('new')">
					<div class="ranking-title">新商家</div>
					<div class="ranking-subtitle">近期加入</div>
				</div>
			</div>

			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-empty v-if="!loading && finished && list.length === 0" description="暂无数据，逛逛别的分类吧~" />
				<van-list :offset="40" v-else v-model="loading" :finished="finished" :immediate-check="false"
					:finished-text="finished ? '没有更多了~' : ''" @load="onLoad">
					<div class="merchant-card bg_a flex_a" v-for="item in list" :key="item.id" @click="goDetail(item.id)">
						<div class="merchant-logo">
							<img v-if="item.logo" class="merchant-logo-img" :src="getImageUrl(item.logo)" />
						</div>
						<div class="merchant-main flex_b">
							<div class="merchant-name ellipsis_1">{{ item.retailerName }}</div>
							<div class="merchant-rebate">
								{{ item.memberCommissionValue }}%返利
							</div>
							<div class="merchant-desc ellipsis_1">{{ item.synopsis }}</div>
						</div>
					</div>
				</van-list>

			</van-pull-refresh>
		</div>

		<div class="back-to-top" :class="{ show: showBackToTop }" @click="scrollToTop">
			<van-icon name="back-top" />
		</div>

		<van-popup v-model="showPopup" closeable position="center" :close-on-click-overlay="false" close-on-popstate
			:style="{ width: '80%',maxHeight:'70%'}" class="popup-notice">
			<div class="popup-content">
				<div class="popup-title">{{ popupMessage.noticeTitle }}</div>
				<div class="popup-text" v-html="popupMessage.noticeContent"></div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		getBannerList,
		getHotList,
		getCommissionList,
		getCreateTimeList,
		getHomePopup,
		imageUrl
	} from '@/apis/api.js'

	export default {
		name: 'Index',
		data() {
			return {
				activeTab: 'hot',
				banners: [],
				showBackToTop: false,
				showPopup: false,
				popupMessage: {},

				refreshing: false,
				list: [],
				pageNum: 0,
				total: 0,
				pageSize: 10,
				loading: false,
				finished: false,
			}
		},
		computed: {
			bannerGroups() {
				const groups = []
				for (let i = 0; i < this.banners.length; i += 6) {
					groups.push(this.banners.slice(i, i + 6))
				}
				return groups
			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			this.loadBanner()
			this.loadPopup()
			this.onLoad();
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		methods: {
			getImageUrl(path) {
				return imageUrl(path)
			},
			loadBanner() {
				getBannerList()
					.then(res => {
						this.banners = res.rows || []
					})
					.catch(() => {
						this.banners = []
					})
			},
			getList() {
				this.pageNum++;
				const apiMap = {
					hot: getHotList,
					high: getCommissionList,
					new: getCreateTimeList
				}
				const api = apiMap[this.activeTab] || getHotList
				api({
						pageNum: this.pageNum,
						pageSize: this.pageSize
					})
					.then(res => {
						const rows = res.rows || [];
						const total = res.total || 0;
						this.total = total;
						this.list = this.list.concat(rows)
						if (this.list.length >= this.total) {
							this.finished = true;
						} else {
							this.finished = false;
						}
					})
					.catch(e => {
						this.finished = true
						if (!e.handled) {
							this.$toast('加载失败')
						}
					})
					.finally(() => {
						this.loading = false;
						this.refreshing = false;
					});
			},
			onLoad() {
				if (this.refreshing || this.finished) {
					return;
				}
				this.getList();
			},
			onRefresh() {
				this.pageNum = 0
				this.list = []
				this.finished = false;
				this.getList()
			},
			onTabChange(key) {
				this.activeTab = key
				this.list = []
				this.pageNum = 0
				this.total = 0
				this.loading = true
				this.finished = false
				this.getList()
			},
			loadPopup() {
				getHomePopup()
					.then(res => {
						if (res && res.noticeId) {
							this.popupMessage = res
							this.showPopup = true
						}
					})
					.catch(e => {
						if (!e.handled) console.log('首页弹窗加载失败')
					})
			},
			goDetail(id) {
				this.$router.push('/detail?id=' + id)
			},
			handleScroll() {
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				this.showBackToTop = scrollTop > 300
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-bottom: 70px;

		.search-bar {
			padding: 10px 14px;

			.index_search {
				padding: 0 14px;
				background-color: #F6F6F6;
				height: 36px;
				line-height: 36px;
				border-radius: 18px;
				color: #9a9a9a;
			}
		}

		.content {
			padding: 10px 14px;
			box-sizing: border-box;

			.index_swiper {
				width: 100%;
				height: 230px;
				border-radius: 10px;
				overflow: hidden;

				.swiper-item {
					height: 100%;

					.brand-grid {
						padding: 10px 12px;
						display: grid;
						grid-template-columns: repeat(3, 1fr);
						grid-template-rows: repeat(2, 1fr);

						.brand-item {
							text-align: center;
							overflow: hidden;
							width: 100%;
							height: 100px;
							flex-direction: column;

							.brand-logo {
								width: 100%;
								height: 40px;
								overflow: hidden;

								.brand-logo-img {
									width: 100%;
									height: 100%;
									object-fit: contain;
								}
							}

							.brand-name {
								width: 100%;
								color: #484848;
								font-size: 13px;
							}

							.brand-rebate {
								width: 100%;
								color: #df3838;
								font-size: 13px;
							}
						}
					}
				}
			}

			.ranking-tabs {
				padding: 20px 0 14px;

				.ranking-tab {
					text-align: center;
					color: #444444;

					.ranking-title {
						font-size: 19px;
						line-height: 1.5;
						font-weight: bold;
					}

					.ranking-subtitle {
						padding: 0 8px;
						margin-top: 4px;
						color: #9a9a9a;
						font-size: 12px;
						height: 20px;
						line-height: 20px;
					}

					&.active {
						.ranking-title {
							color: #e33737;
						}

						.ranking-subtitle {
							padding: 0 8px;
							color: #ffffff;
							background: #e33737;
							border-radius: 10px;
						}
					}
				}
			}

			.merchant-card {
				height: 80px;
				margin-bottom: 10px;
				padding: 12px 10px;
				border-radius: 10px;

				.merchant-logo {
					flex: none;
					width: 80px;
					height: 80px;
					background: #fff;
					border-radius: 8px;
					overflow: hidden;
					margin-right: 12px;

					.merchant-logo-img {
						width: 100%;
						height: 100%;
						border-radius: 8px;
						overflow: hidden;
						object-fit: contain;
					}
				}

				.merchant-main {
					flex: 1;
					height: 80px;
					flex-direction: column;

					.merchant-name {
						width: 100%;
						font-size: 14px;
						color: #222222;
						font-weight: bold;
					}

					.merchant-rebate {
						width: 100%;
						color: #e33737;
						font-size: 12px;
					}

					.merchant-desc {
						width: 100%;
						color: #909090;
						font-size: 12px;
					}
				}
			}
		}

		.back-to-top {
			position: fixed;
			right: 20px;
			bottom: 90px;
			width: 44px;
			height: 44px;
			background: #ffffff;
			border-radius: 50%;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
			display: flex;
			align-items: center;
			justify-content: center;
			opacity: 0;
			visibility: hidden;
			transition: all 0.3s ease;
			z-index: 1000;

			&.show {
				opacity: 1;
				visibility: visible;
			}

			.van-icon {
				font-size: 24px;
				color: #444;
			}
		}

		.popup-notice {
			.popup-content {
				padding: 24px 20px 20px;
				text-align: center;

				.popup-title {
					font-size: 16px;
					font-weight: bold;
					color: #333;
					margin-bottom: 12px;
				}

				.popup-text {
					font-size: 14px;
					color: #666;
					line-height: 1.5;
					word-break: break-all;

					:deep(p) {
						margin-bottom: 10px;
					}

					:deep(ul),
					:deep(ol) {
						padding-left: 20px;
						margin: 10px 0;
					}

					:deep(li) {
						margin: 5px 0;
					}
				}

			}
			:deep(.van-icon){
				font-size:20px;
				color:#333;
			}
		}

	}
</style>